import React, {Fragment} from 'react'
import {Breadcrumb, Card, Icon, Row, Tabs} from 'antd'
import style from './style.css'
import PaymentsList from './PaymentsList'
import {withRouter} from 'react-router-dom'
import {get} from 'lodash'
import ReceiptsCont from './Receipts/ReceiptsCont'
import useTitle from '../../../elements/Hooks/useTitle'

const {TabPane} = Tabs

function Payments(props) {
  useTitle('Payments')
  return (
    <Fragment>
      <Card>
        <Row className={style.pageHeader}>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Sales</Breadcrumb.Item>
            <Breadcrumb.Item>Payments</Breadcrumb.Item>
          </Breadcrumb>
          <h1 className={style.title}>
            <Icon type="dollar" style={{marginRight: 10, color: '#c97809'}} />
            Payments
          </h1>
          <p className={style.paragraph}>
            View and list unallocated client payments.
          </p>
        </Row>
      </Card>
      <Card className={style.contentCard}>
        <Tabs
          defaultActiveKey={get(props, 'location.hash') || '#payments'}
          onChange={key => props.history.push(key)}>
          <TabPane tab="Payments" key="#payments">
            <PaymentsList {...props} />
          </TabPane>
          <TabPane tab="Receipts" key="#receipts">
            <ReceiptsCont />
          </TabPane>
        </Tabs>
      </Card>
    </Fragment>
  )
}

Payments.propTypes = {}
Payments.defaultProps = {}

export default withRouter(Payments)
